import { Tooltip, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useNavigate } from "react-router-dom";
import {targets, useReferentialContext} from "../../Context";


export default function ChampionIcon(props: {champion: string, role:string, sx? :any, size?: number, respawn_timer?:number, disable_link?: boolean}){
    const isRespawning = props.respawn_timer && props.respawn_timer > 0;
    const navigate = useNavigate();

    const ctx = useReferentialContext() as any;
    const getChampionDetailsRoute = () => {
        if (ctx.currentTarget === targets.competitive) return '/champions-details-competitive';
        if (ctx.currentTarget === targets.soloq) return '/champions-details-soloq';
        if (ctx.currentTarget === targets.scrims) return '/champions-details-scrims';
        return '/champions-details-competitive'; // default fallback
    };
    
    return <Tooltip title={props.disable_link ? null : `Check ${ctx.ddragon_champions[props.champion]?.name} stats for ${ctx.currentTarget}`} followCursor={true}>
        <Box sx={{ position: "relative", display: "inline-block", height:`${props.size ? props.size : 40}px`, width:`${props.size ? props.size : 40}px`, ...props.sx }}>
            <Box component={"img"}
                 src={`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${(props.size ? props.size : 40) * 2},w_${(props.size ? props.size : 40) * 2}/championAssets/${props.champion}.png`}
                 style={{
                     width: `${props.size ? props.size : 40}px`,
                     height: `${props.size ? props.size : 40}px`,
                     objectFit: 'cover',
                     imageRendering: 'crisp-edges'
                 }}
            onClick={() => {
                if(!props.disable_link) {
                    ctx.setSelectedRole(props.role);
                    ctx.setSelectedChampion(ctx.championsReferential.filter((c: any) => c.id === props.champion)[0]);
                    navigate(getChampionDetailsRoute());
                }
            }} sx={{filter: isRespawning ? "grayscale(100%) brightness(50%)" : "none", cursor: 'pointer', ...props.sx}}/>
                {isRespawning ? (
                    <Typography
                        variant="caption"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            padding: "2px 4px",
                            borderRadius: "4px",
                        }}
                    >
                        {props.respawn_timer?.toFixed(1)}s
                    </Typography>
                ) : null}
            </Box>
            </Tooltip>
}